import React, { useEffect } from "react";
import Html from "utils/Html";
import Func from "utils/Func";
import { Dropdown } from "semantic-ui-react";
import { useNotify } from "context/NotifyContext";

export default function FilterDepartment({ data }) {
  const { filters, storeFilters } = useNotify();
  const filterName = "department";
  const filterTitle = "Department";
  let handleEvents = {
    SelectNone: {
      OnClick: function (evt) {
        let selectedArr = [];
        // console.log("Btn Select None => " + filterName);
        storeFilters({
          ...filters,
          department: selectedArr,
          keyChange: Func.GetKeyRandom(),
        });
      },
    },
    SelectAll: {
      OnClick: function (evt) {
        let selectedArr = [];
        for (const i in itemData) {
          selectedArr.push(itemData[i].dept_id);
        }
        // console.log("Btn Select All => " + filterName, selectedArr);
        storeFilters({
          ...filters,
          department: selectedArr,
          keyChange: Func.GetKeyRandom(),
        });
      },
    },
    OnChange: function (evt, { name, value }) {
      // console.log(name, value);
      storeFilters({
        ...filters,
        department: value,
        keyChange: Func.GetKeyRandom(),
      });
    },
  };
  useEffect(() => {}, []);
  let itemData = [];
  let country = [];
  let n = 0;
  if ("country" in filters && filters.country.length > 0) {
    country = filters.country;
    n = country.length;
  }
  for (let i in country) {
    let country_code = country[i];
    if (country_code in data) {
      itemData = itemData.concat(data[country_code]);
    }
  }
  return (
    <div
      key={"filter-" + filterName + "-" + filters.key_form}
      className="filter-input-field select"
    >
      <Html.SelectAll handleEvents={handleEvents} />
      <label htmlFor={"filter-inp-" + filterName} className="label">
        {filterTitle}
      </label>
      <Dropdown
        fluid
        selection
        search={true}
        multiple={true}
        id={"filter-inp-" + filterName}
        name={filterName}
        placeholder={filterTitle}
        options={Html.OptionList(itemData, {
          id: "",
          key: filterName,
          name: n > 1 ? "display_name" : "name",
          value: "name",
          optionGroup: false,
          optionNull: false,
        })}
        value={filters?.department ?? []}
        onChange={handleEvents.OnChange}
        disabled={false}
      />
      <span
        className="select-helper-text hide"
        id={"helper-text-" + filterName}
      >
        {"Please select " + filterName}
      </span>
    </div>
  );
}
